<template>
    <el-drawer
        title="创建艺人"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                v-loading="dataLoading"
            >
                <el-form-item prop="avatar" label="头像:">
                    <image-upload :url.sync="formData.avatar" :urlFull.sync="formData.avatar" :crop="true" :width="800"
                        :height="800" class="avatar" @onSuccess="handleAvatarSuccess">
                    </image-upload>
                </el-form-item>
                <el-form-item prop="name" label="艺人名称:">
                    <el-input
                        v-model="formData.name"
                        placeholder="请输入艺人名称"
                        size="medium"
                        maxlength="40"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="type" label="艺人形式:">
                    <el-radio-group v-model="formData.type" size="medium">
                        <el-radio :label="1">个人</el-radio>
                        <el-radio :label="2">团体</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="formData.type == 2" prop="memberCount" label="成员人数:">
                    <el-input-number style="width:100%" v-model="formData.memberCount" :precision="0" controls-position="right" :min="1" :max="99999999" size="medium" placeholder="请输入成员人数"></el-input-number>
                </el-form-item>
                <el-form-item prop="styles" label="风格">
                    <el-cascader
                        v-model="styles"
                        :options="styleList"
                        filterable
                        :props="{multiple:true,label:'name',children:'tags',value:'id',emitPath:true,checkStrictly:true}"
                        size="medium"
                        style="width:100%"
                        @change="selectStyles"
                        ref="stylesCascader">
                        <template slot-scope="{ node, data }">
                            <span>{{ data.name }}</span>
                            <span v-if="!node.isLeaf"> ({{ data.tags.length }}) </span>
                        </template>
                    </el-cascader>
                </el-form-item>
                <el-form-item prop="city" label="所在城市">
                    <el-cascader
                        v-model="formData.city"
                        :options="cityList"
                        filterable
                        :props="{label:'name',children:'cityList',value:'code',emitPath:false}"
                        size="medium"
                        style="width:100%"
                        ref="cityCascader">
                    </el-cascader>
                </el-form-item>
                <el-form-item prop="desc" label="艺人介绍:">
                    <el-input type="textarea" v-model="formData.desc" placeholder="请输入艺人介绍" size="medium"
                        maxlength="500"></el-input>
                </el-form-item>
                <div v-if="customArtist" class="MT20">
                    <el-button type="primary" @click="submitForm()" :loading="btnLoading">创建艺人并绑定</el-button>
                    <el-button type="warning" @click="isBindArtist = true" :loading="btnLoading">仅绑定艺人</el-button>
                </div>
            </el-form>
            <!-- 如果是自定义艺人，可绑定正式艺人，否则无需绑定 -->
            <el-form v-if="isBindArtist" :model="bindArtistForm" ref="bindArtistForm" label-position="top" class="MT20">
                <el-form-item prop="value" :rules="[{ required: true, message: '请选择演出艺人' }]">
                    <span slot="label">绑定正式艺人: </span>
                    <el-select v-model="bindArtistForm.value" filterable remote placeholder="请输入演出艺人"
                        :remote-method="searchArtist" :loading="userLoading" size="medium" value-key="id">
                        <el-option v-for="item in artistList" :key="item.id" :label="item.name" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div class="MT20">
                    <el-button type="primary" @click="bindArtist()" :loading="btnLoading">完成绑定</el-button>
                </div>
            </el-form>
        </div>
        <div v-if="!customArtist" class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {fetchAllTag,fetchAllCity, fetchUser } from '@/assets/js/commonApi'
import ImageUpload from '@/components/ImageUpload'
const defaultFormData = {
    name: "",
    type: 1,
    memberCount: 1,
    styles:[],
    tags:[],
    city:10,
    avatar:'',
    desc:'',
    // password:'Thshowstart123'
}
export default {
    components:{
        ImageUpload,
    },
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                name: [{ required: true, message: "请输入艺人名称" }],
                memberCount: [{ required: true, message: "请输入成员人数" }],
                styles:[{required: true, message: '请选择风格'}],
                city:[{required: true, message: '请选择所在城市'}],
            },
            styles:[],
            styleList:[],//所有风格Tag集合
            cityList:[],//所有省份城市集合


            customArtist: null,
            isBindArtist:false,
            artistList:[],//所有艺人集合
            bindArtistForm:{
                value:null,
            },
            userLoading:false,
        };
    },
    mounted(){
        this.getStyleList()
        this.getCityList()
    },
    methods: {
        close() {
            // this.$refs.stylesCascader.clearCheckedNodes();
            // this.$refs.cityCascader.clearCheckedNodes();
           // this.formData = {...defaultFormData};
            this.styles = [];
            // this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(customArtist) {
            this.customArtist = customArtist;
            this.isBindArtist = false;
            if( customArtist ){
                this.formData = {
                    ...defaultFormData,
                    ...this.customArtist,
                    avatar:this.customArtist.poster || '',
                    poster: '',
                    styles: this.customArtist.styles || [],
                    tags: this.customArtist.tags || [],
                    city: this.customArtist.city ? Number(this.customArtist.city) : defaultFormData.city,
                };
                this.styles = [];
                // 处理已选风格
                if (this.formData.styles && this.formData.styles.length > 0) {
                    this.formData.styles.forEach(styleId => {
                        const styleItem = this.styleList.find(s => s.id == styleId);
                        if (styleItem && styleItem.tags && styleItem.tags.length > 0) {
                            const tagItem = styleItem.tags.filter(t => this.formData.tags && this.formData.tags.includes(t.id.toString()));
                            if (tagItem && tagItem.length > 0) {
                                tagItem.forEach(t => {
                                    this.styles.push([Number(styleId), Number(t.id)]);
                                })
                            } else {
                                this.styles.push([Number(styleId)]);
                            }
                        } else {
                            this.styles.push([Number(styleId)]);
                        }
                    });
                }
            }else{
                this.formData = {...defaultFormData,styles:[],tags:[]};
                this.styles = [];
            }
            this.drawerShow = true;
            this.$nextTick(() => {
                this.bindArtistForm.value = null;
                this.$refs["formData"].clearValidate();
            })
        },
        
        //获取所有风格
        async getStyleList(){
            const res = await fetchAllTag({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.styleList = result;
            }
        },
        //获取所有城市
        async getCityList(){
            const res = await fetchAllCity({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.cityList = result;
            }
        },
        //选取风格
        selectStyles(){
            // 风格&tag id组装
            let _styles = [], _tags = [];
            this.styles.forEach( item =>  {
                _styles.push( item[0] );
                if(item[1]){
                    _tags.push( item[1] ); 
                }
            })

            this.formData.styles = _styles ? [...new Set(_styles)] : [];
            this.formData.tags = _tags ? [...new Set(_tags)] : [];
        }, 
        // 头像上传成功
        handleAvatarSuccess(){
            if (this.formData.avatar) {
                this.$refs["formData"].clearValidate('avatar');
            }
        },
        // 搜索艺人
        async searchArtist(query) {
            if (query !== "") {
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue: query,
                    userType: 2,
                }).finally(() => {
                    this.userLoading = false;
                });

                const {
                    state,
                    result
                } = res.data;

                if (state == 1 && result) {
                    this.artistList = result;
                }
            }
        },
        //表单提交
        submitForm() {
            // console.log(this.formData)
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    const _url = "/performer/save";
                    this.btnLoading = true;

                    this.$request({
                        url: _url,
                        data: {
                            ...this.formData,
                            memberCount: this.formData.type == 2 ? this.formData.memberCount : 1,
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg, result } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate',result);
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        //绑定正式艺人
        bindArtist(){
            this.$refs["bindArtistForm"].validate((valid) => {
                if (valid) {
                    this.$emit('onUpdate', this.bindArtistForm.value);
                    this.close();
                }
            })
        }
    },
};
</script>
